<!-- This snippet uses Font Awesome 5 Free as a dependency. You can download it at fontawesome.io! -->

<section [ngClass]="lang" class="pricing py-5">
  <div class="container">

    <div class="row">
      <div *ngIf="lang=='en'" class="col-12 mb-4 text-center wow fadeInRightBig" data-wow-delay="0s">
        <h2>
          Our Packages
        </h2>
      </div>
      <div *ngIf="lang=='ar'" class="col-12 mb-4 text-center wow fadeInLeftBig" data-wow-delay="0s">
        <h2>
          باقاتنا
        </h2>
      </div>
    </div>

    <div class="row">

      <!--Starter Tier -->
      <div [ngClass]="{fadeInLeft:lang=='en',fadeInRight:lang=='ar'}" class="col-lg-3 col-md-6 col-sm-6 mt-3 wow">
        <div class="card mb-1 mb-lg-0">
          <div class="card-body">
            <h5 *ngIf="lang=='en'" class="card-title text-muted text-uppercase text-center">
              Starter
            </h5>
            <h5 *ngIf="lang=='ar'" class="card-title text-muted text-uppercase text-center">
              الإنطلاقة
            </h5>
            <h6 *ngIf="lang=='en'" class="card-price text-center">
              220 SDG<span class="period">/month</span>
              <br />
              <div style="text-decoration: line-through;">600 SDG<span class="period">Normally</span></div>
            </h6>
            <h6 *ngIf="lang=='ar'" class="card-price text-center">
              220 جنيه<span class="period"> \شهرياً</span>
              <br />
              <div style="text-decoration: line-through;">600 جنيه<span class="period"> عادي</span></div>
            </h6>
            <hr />
            <ul class="fa-ul">

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>1 Website
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>1 موقع الإكتروني
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>50GB SSD
                Storage
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>50GB SSD
                مساحة القرص
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unmetered
                Bandwidth
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>سعة النقل غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Free SSL
                Certificate
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>شهادة SSL مجانية
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Standard
                Performance
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>الأداء القياسي
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>1
                Included Domain (sd)
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>1
                النطاق الداخلي (sd)
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>5 Parked
                Domains
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>حجز النطاق مسموح 5
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>25 Sub
                Domains
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>25 النطاقات الفرعية
              </li>

              <!-- <li *ngIf="lang=='en'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>Spam Experts
              </li>
              <li *ngIf="lang=='ar'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>حماية من البريد المزعج
              </li>

              <li *ngIf="lang=='en'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>Domain Privacy + Protection
              </li>
              <li *ngIf="lang=='ar'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>خصوصية وحماية اسم نطاق الانترنت
              </li>

              <li *ngIf="lang=='en'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>Site Backup
              </li>
              <li *ngIf="lang=='ar'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span> النسخ الاحتياطي
              </li>

              <li *ngIf="lang=='en'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>Dedicated IP
              </li>
              <li *ngIf="lang=='ar'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>IP منفصل
              </li> -->

            </ul>
            <a *ngIf="lang=='en'" data-toggle="modal" data-target="#orangeModalSubscription" data-whatever="Starter"
              class="btn btn-block btn-primary text-uppercase">Buy</a>
            <a *ngIf="lang=='ar'" data-toggle="modal" data-target="#orangeModalSubscription" data-whatever="Starter"
              class="btn btn-block btn-primary text-uppercase">أطلب</a>
          </div>
        </div>
      </div>

      <!--Plus Tier -->
      <div class="col-lg-3 col-md-6 col-sm-6 mt-3 wow fadeInUp">
        <div class="card mb-1 mb-lg-0">
          <div class="card-body">
            <h5 *ngIf="lang=='en'" class="card-title text-muted text-uppercase text-center">
              Plus
            </h5>
            <h5 *ngIf="lang=='ar'" class="card-title text-muted text-uppercase text-center">
              البلس
            </h5>
            <h6 *ngIf="lang=='en'" class="card-price text-center">
              410 SDG<span class="period">/month</span>
              <br />
              <div style="text-decoration: line-through;">825 SDG<span class="period">Normally</span></div>
            </h6>
            <h6 *ngIf="lang=='ar'" class="card-price text-center">
              410 جنيه<span class="period"> \شهرياً</span>
              <br />
              <div style="text-decoration: line-through;">825 جنيه<span class="period"> عادي</span></div>
            </h6>
            <hr />
            <ul class="fa-ul">

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Website
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>موقع الإكتروني غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited SSD
                Storage
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>مساحة القرص SSD غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unmetered
                Bandwidth
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>سعة النقل غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Free SSL
                Certificate
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>شهادة SSL مجانية
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Standard
                Performance
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>الأداء القياسي
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Domain
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>النطاق الداخلي غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Parked
                Domains
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>حجز
                النطاق غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Sub
                Domains
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>النطاقات الفرعية غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Spam Experts
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>حماية من البريد المزعج
              </li>

              <!-- <li *ngIf="lang=='en'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>Domain Privacy + Protection
              </li>
              <li *ngIf="lang=='ar'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>خصوصية وحماية اسم نطاق الانترنت
              </li>

              <li *ngIf="lang=='en'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>Site Backup
              </li>
              <li *ngIf="lang=='ar'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span> النسخ الاحتياطي
              </li>

              <li *ngIf="lang=='en'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>Dedicated IP
              </li>
              <li *ngIf="lang=='ar'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>IP منفصل
              </li> -->

            </ul>
            <a *ngIf="lang=='en'" class="btn btn-block btn-primary text-uppercase" data-toggle="modal"
              data-target="#orangeModalSubscription" data-whatever="Plus">Buy</a>
            <a *ngIf="lang=='ar'" class="btn btn-block btn-primary text-uppercase" data-toggle="modal"
              data-target="#orangeModalSubscription" data-whatever="Plus">أطلب</a>
          </div>
        </div>
      </div>

      <!--Gold Tire -->
      <div class="col-lg-3 col-md-6 col-sm-6 mt-3 wow fadeInUp">
        <div class="card mb-1 mb-lg-0">
          <div class="card-body">
            <h5 *ngIf="lang=='en'" class="card-title text-muted text-uppercase text-center">
              Gold
            </h5>
            <h5 *ngIf="lang=='ar'" class="card-title text-muted text-uppercase text-center">
              الذهبي
            </h5>
            <h6 *ngIf="lang=='en'" class="card-price text-center">
              1020 SDG<span class="period">/month</span>
              <br />
              <div style="text-decoration: line-through;">1125 SDG<span class="period">Normally</span></div>
            </h6>
            <h6 *ngIf="lang=='ar'" class="card-price text-center">
              1020 جنيه<span class="period"> \شهرياً</span>
              <br />
              <div style="text-decoration: line-through;">1125 جنيه<span class="period"> عادي</span></div>
            </h6>
            <hr />
            <ul class="fa-ul">

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Website
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>موقع الإكتروني غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited SSD
                Storage
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>مساحة القرص SSD غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unmetered
                Bandwidth
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>سعة النقل غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Free SSL
                Certificate
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>شهادة SSL مجانية
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Standard
                Performance
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>الأداء القياسي
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Domain
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>النطاق الداخلي غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Parked
                Domains
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>حجز
                النطاق غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Sub
                Domains
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>النطاقات الفرعية غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Spam Experts
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>حماية من البريد المزعج
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Domain Privacy + Protection
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>خصوصية وحماية اسم نطاق الانترنت
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Site Backup
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span> النسخ الاحتياطي
              </li>

              <!-- <li *ngIf="lang=='en'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>Dedicated IP
              </li>
              <li *ngIf="lang=='ar'" class="text-muted">
                <span class="fa-li"><i class="fas fa-times"></i></span>IP منفصل
              </li> -->

            </ul>
            <a *ngIf="lang=='en'" class="btn btn-block btn-primary text-uppercase" data-toggle="modal"
              data-target="#orangeModalSubscription" data-whatever="Gold">Buy</a>
            <a *ngIf="lang=='ar'" class="btn btn-block btn-primary text-uppercase" data-toggle="modal"
              data-target="#orangeModalSubscription" data-whatever="Gold">أطلب</a>
          </div>
        </div>
      </div>

      <!--Professional Tire-->
      <div [ngClass]="{fadeInLeft:lang=='ar',fadeInRight:lang=='en'}" class="col-lg-3 col-md-6 col-sm-6 mt-3 wow">
        <div class="card mb-1 mb-lg-0">
          <div class="card-body">
            <h5 *ngIf="lang=='en'" class="card-title text-muted text-uppercase text-center">
              Professional
            </h5>
            <h5 *ngIf="lang=='ar'" class="card-title text-muted text-uppercase text-center">
              الأحتراف
            </h5>
            <h6 *ngIf="lang=='en'" class="card-price text-center">
              1650 SDG<span class="period">/month</span>
              <br />
              <div style="text-decoration: line-through;">1800 SDG<span class="period">Normally</span></div>
            </h6>
            <h6 *ngIf="lang=='ar'" class="card-price text-center">
              1650 جنيه<span class="period"> \شهرياً</span>
              <br />
              <div style="text-decoration: line-through;">1800 جنيه<span class="period"> عادي</span></div>
            </h6>
            <hr />
            <ul class="fa-ul">

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Website
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>موقع الإكتروني غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited SSD
                Storage
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>مساحة القرص SSD غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unmetered
                Bandwidth
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>سعة النقل غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Free SSL
                Certificate
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>شهادة SSL مجانية
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Standard
                Performance
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>الأداء القياسي
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Domain
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>النطاق الداخلي غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Parked
                Domains
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>حجز
                النطاق غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Sub
                Domains
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>النطاقات الفرعية غير محدود
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Spam Experts
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>حماية من البريد المزعج
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Domain Privacy + Protection
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>خصوصية وحماية اسم نطاق الانترنت
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Site Backup
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span> النسخ الاحتياطي
              </li>

              <li *ngIf="lang=='en'">
                <span class="fa-li"><i class="fas fa-check"></i></span>Dedicated IP
              </li>
              <li *ngIf="lang=='ar'">
                <span class="fa-li"><i class="fas fa-check"></i></span>IP منفصل
              </li>

            </ul>
            <a *ngIf="lang=='en'" class="btn btn-block btn-primary text-uppercase" data-toggle="modal"
              data-target="#orangeModalSubscription" data-whatever="Pro">Buy</a>
            <a *ngIf="lang=='ar'" class="btn btn-block btn-primary text-uppercase" data-toggle="modal"
              data-target="#orangeModalSubscription" data-whatever="Pro">أطلب</a>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<div class="modal fade" id="orangeModalSubscription" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-notify modal-warning" role="document">
    <!--Content-->
    <form id="price" [ngClass]="lang" method="post" class="form-area contact-form text-right">
      <div class="modal-content">
        <!--Header-->
        <div class="modal-header text-center">
          <h4 class="modal-title white-text w-100 font-weight-bold py-2" *ngIf="lang == 'en'">Subscribe</h4>
          <h4 class="modal-title white-text w-100 font-weight-bold py-2" *ngIf="lang == 'ar'">الإشتراك</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" class="white-text">&times;</span>
          </button>
        </div>

        <!--Body-->
        <div class="modal-body">

          <div class="row">
            <div class="col-lg-12 form-group d-flex flex-column">


              <div *ngIf="lang=='en'" class='alert alert-danger row alert-dismissible' style="display: none;"
                role='alert'>
                <h4 class='alert-heading'>Failed to send message
                  Try again!</h4>
                <button type='button' class='close' data-dismiss='alert' aria-label='Close'>
                  <span aria-hidden='true'>&times;</span>
                </button>
              </div>

              <div *ngIf="lang=='ar'" class='alert alert-danger row alert-dismissible' style="display: none;"
                role='alert'>
                <h4 class='alert-heading'>فشل ارسال الرسالة
                  اعد محاولة مرة اخرى!</h4>
                <button type='button' class='close' data-dismiss='alert' aria-label='Close'>
                  <span aria-hidden='true'>&times;</span>
                </button>
              </div>

              <input *ngIf="lang == 'en'" name="name" placeholder="Enter your name" onfocus="this.placeholder = ''"
                onblur="this.placeholder='Enter your name'" class="common-input form-control" required="" type="text" />
              <input *ngIf="lang == 'ar'" name="name" placeholder="الأسم" onfocus="this.placeholder = ''"
                onblur="this.placeholder='الأسم'" class="common-input form-control" required="" type="text" />

              <input *ngIf="lang == 'en'" name="email" placeholder="Enter email address"
                pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$" onfocus="this.placeholder = ''"
                onblur="this.placeholder='Enter email address'" class="common-input form-control mt-2" required=""
                type="email" />
              <input *ngIf="lang == 'ar'" name="email" placeholder="البريد الإلكتروني"
                pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$" onfocus="this.placeholder = ''"
                onblur="this.placeholder='البريد الإلكتروني'" class="common-input form-control mt-2" required=""
                type="email" />

              <input *ngIf="lang == 'en'" name="phone" placeholder="Enter phone number" onfocus="this.placeholder = ''"
                onblur="this.placeholder='Enter phone number'" class="common-input form-control mt-2" required=""
                type="phone" />
              <input *ngIf="lang == 'ar'" name="phone" placeholder="الرقم الهاتف" onfocus="this.placeholder = ''"
                onblur="this.placeholder='الرقم الهاتف'" class="common-input form-control mt-2" required=""
                type="phone" />

              <input name="subject" type="hidden" />
              <input name="message" type="hidden" />
            </div>

          </div>
        </div>

        <!--Footer-->
        <div class="modal-footer justify-content-center">


          <button *ngIf="lang == 'en'" class="btn waves-effect mt-1 col-12 m-auto">
            <div class="submit-p-btn">
              Buy<i class="fas fa-magic ml-2"></i>
            </div>
            <div class="loading-p-btn">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="p-1">Sending...</span>
            </div>
          </button>

          <button *ngIf="lang == 'ar'" class="btn waves-effect mt-1 col-12 m-auto">
            <div class="submit-p-btn">
              أطلب<i class="fas fa-magic ml-2"></i>
            </div>
            <div class="loading-p-btn">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="p-1">جاري الطلب...</span>
            </div>
          </button>
        </div>
      </div>
    </form>
    <!--/.Content-->
  </div>
</div>
